import AdminQuestion from '@/adapters/AdminQuestion';
import AdminWord from '@/adapters/AdminWord';
import AdminQuestionRepository from '@/API/AdminQuestionRepository';
import AdminWordRepository from '@/API/AdminWordRepository';
import { StoreMutations } from "./mutations";

export const StoreActions = {
    getQuestions: 'getQuestions',
    getWord: 'getWord',
    clearState: 'clearState',
};

export const actions = {
    [StoreActions.getQuestions] ({ commit, state }) {
        commit(StoreMutations.SET_LOADING, true);

        AdminQuestionRepository.getForWord(state.wordId).then((data) => {
            let questions = data.questions.map(it => {
                return new AdminQuestion(it);
            })
            commit(StoreMutations.SET_QUESTIONS, questions);
        }).catch( err => {
            commit(StoreMutations.SET_ERROR, err);
        }).finally(() => {
            commit(StoreMutations.SET_LOADING, false);
        })
    },
    [StoreActions.getWord] ({commit, state}) {
        AdminWordRepository.get(state.wordId).then(data => {
            let word = new AdminWord(data.word);
            commit(StoreMutations.SET_WORD, word);
        }).catch(err => {
            commit(StoreMutations.SET_ERROR, err);
        })
    },
    [StoreActions.clearState] ({ commit }) {
        commit(StoreMutations.SET_WORD_ID, null);
        commit(StoreMutations.SET_QUESTIONS, []);
        commit(StoreMutations.SET_LOADING, false);
        commit(StoreMutations.SET_ERROR, null);
    }
}